import { GridRowId } from '@mui/x-data-grid-premium'
import { useCallback, useMemo, useState } from 'react'

export function useTreeExpansionPersistence(context: string) {
  const localStorageKey = `${context}ExpandedRowIds`

  const [expandedRowIds, setExpandedRowIds] = useState<GridRowId[]>(() => {
    try {
      const saved = localStorage.getItem(localStorageKey)
      return saved ? JSON.parse(saved) : []
    } catch (err) {
      console.warn('Failed to parse expandedRowIds from localStorage:', err)
      return []
    }
  })

  // ✅ O(1) lookups and stable reference between renders when ids don’t change
  const expandedSet = useMemo(() => new Set(expandedRowIds), [expandedRowIds])

  // ✅ stable function identity (only changes when expandedSet changes)
  const isExpanded = useCallback((id: GridRowId) => expandedSet.has(id), [expandedSet])

  // ✅ stable function identity; uses functional setState so no stale closures
  const toggleExpanded = useCallback(
    (id: GridRowId) => {
      setExpandedRowIds(prev => {
        const next = prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        localStorage.setItem(localStorageKey, JSON.stringify(next))
        return next
      })
    },
    [localStorageKey]
  )

  const setPersistedExpanded = useCallback(
    (ids: GridRowId[]) => {
      setExpandedRowIds(ids)
      localStorage.setItem(localStorageKey, JSON.stringify(ids))
    },
    [localStorageKey]
  )

  return {
    expandedRowIds,
    expandedSet, // optional, but useful
    isExpanded,
    toggleExpanded,
    setExpandedRowIds: setPersistedExpanded,
  }
}

// import { useState, useEffect } from 'react'
// import { GridRowId } from '@mui/x-data-grid-premium'

// export function useTreeExpansionPersistence(context: string) {
//   const localStorageKey = `${context}ExpandedRowIds`

//   const [expandedRowIds, setExpandedRowIds] = useState<GridRowId[]>(() => {
//     try {
//       const saved = localStorage.getItem(localStorageKey)
//       return saved ? JSON.parse(saved) : []
//     } catch (err) {
//       console.warn('Failed to parse expandedRowIds from localStorage:', err)
//       return []
//     }
//   })

//   const isExpanded = (id: GridRowId) => expandedRowIds.includes(id)

//   const toggleExpanded = (id: GridRowId) => {
//     setExpandedRowIds(prev => {
//       const newExpanded = prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
//       localStorage.setItem(localStorageKey, JSON.stringify(newExpanded))
//       return newExpanded
//     })
//   }

//   const setPersistedExpanded = (ids: GridRowId[]) => {
//     setExpandedRowIds(ids)
//     localStorage.setItem(localStorageKey, JSON.stringify(ids))
//   }

//   return {
//     expandedRowIds,
//     isExpanded,
//     toggleExpanded,
//     setExpandedRowIds: setPersistedExpanded,
//   }
// }
